import { useActiveInSessionData } from '../hooks/useActiveInSessionData';
import { ACTIVE_IN_SESSION } from '../api/simGraphsApi';
import { useTranslation } from 'react-i18next';

import { EntryListWidget } from 'src/common/components/Widgets/EntryListWidget/EntryListWidget';
import { WidgetEntryList } from 'src/common/components/Widgets/EntryListWidget/WidgetEntryList';
import { accountsFilterAtom } from 'src/atoms/filters/sim-products';
import { GraphAccountsValidator } from 'src/products/GraphAccountValidator';
import { useAccountRefs } from 'src/common/components/Accounts/useAccountRefs';
import { ActiveStateChartPlaceholder } from 'src/products/GraphValidatorPlaceholders';

const ActiveStateContent = ({ accountRef }: { accountRef: string }) => {
  const { data } = useActiveInSessionData({ accountRef });

  const { t } = useTranslation();

  const entries = [
    {
      label: t('dashboard.activeInSessionChart.legend.inSession'),
      value: data.data[ACTIVE_IN_SESSION.IN_SESSION],
    },
    {
      label: t('dashboard.activeInSessionChart.legend.outOfSession'),
      value: data.data[ACTIVE_IN_SESSION.OUT_OF_SESSION],
    },
  ];

  return <WidgetEntryList entries={entries} />;
};

export const SimActiveStateWidget = () => {
  const { t } = useTranslation();
  const accountRefs = useAccountRefs({ cslAccountAtom: accountsFilterAtom });

  const title = t('dashboard.activeInSessionChart.title');

  return (
    <GraphAccountsValidator
      accountRefs={accountRefs}
      fallback={<ActiveStateChartPlaceholder title={title} />}
    >
      <EntryListWidget title={title} expectedRows={2} accountRef={accountRefs[0]}>
        {(accountRef) => <ActiveStateContent accountRef={accountRef} />}
      </EntryListWidget>
    </GraphAccountsValidator>
  );
};
